import {
  AddFilesResponse,
  DeleteResponse,
  MoveResponse,
} from '@/types/folders/folder';
import { httpServices } from '../axiosClient';
import {
  mockUploadDocument,
  mockRenameDocument,
  mockDeleteDocument,
  mockEditDocumentTags,
  mockMoveDocument,
} from '../mock/documents/services/mockDocumentService';

const USE_MOCK = import.meta.env.VITE_USE_MOCK_DB === 'true';

export const uploadDocument = async (params: any, data: any) => {
  const response = await httpServices.llmService.post<AddFilesResponse>(
    `/document/multiple`,
    data,
    params,
  );
  return response;
};

export const renameDocument = async (params: any) => {
  if (USE_MOCK) {
    return mockRenameDocument(params);
  }
  const response = await httpServices.llmService.post<any>(
    `/document/rename`,
    {},
    params,
  );
  return response;
};

export const deleteDocument = async (data: any) => {
  if (USE_MOCK) {
    return mockDeleteDocument(data);
  }
  const response = await httpServices.llmService.delete<DeleteResponse>(
    `/document/${data.document_id}`,
    data,
  );
  return response;
};

export const editDocmentTags = async (document_id: string, data: any) => {
  if (USE_MOCK) {
    return mockEditDocumentTags(document_id, data);
  }
  const response = await httpServices.llmService.post(
    `/document/${document_id}/tags`,
    data,
  );
  return response;
};

export const moveDocument = async (data: any) => {
  if (USE_MOCK) {
    return mockMoveDocument(data);
  }
  const response = await httpServices.llmService.post<MoveResponse>(
    `/document/move`,
    {},
    data,
  );
  return response;
};
